import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, from, Observable, throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { Payment } from 'src/app/pages/billing/models/payment';
import { PaymentOption } from 'src/app/pages/billing/models/PaymentOption';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private transactionsSubject = new BehaviorSubject<any[]>([]);
  transactions$ = this.transactionsSubject.asObservable();

  private async getAuthHeaders(): Promise<HttpHeaders> {
    const token = await this.authService.getToken();
    return new HttpHeaders().set('Authorization', `Bearer ${token}`);
  }
  
  constructor(private http: HttpClient, private authService: AuthService) {}

  addPaymentMethod(model: any): Observable<Payment> {
    return this.http.post<Payment>(`${environment.resourceUrl}/api/payment/create`, model);
  }

  updatePaymentMethod(model: any): Observable<Payment> {
    return this.http.post<Payment>(`${environment.resourceUrl}/api/payment/update`, model);
  }

  getPaymentOptions(): Observable<PaymentOption[]> {
    return this.http.get<PaymentOption[]>(
      `${environment.resourceUrl}/api/payment/list`
    );
  }

  getPaymentOptionById(id: string): Observable<PaymentOption> {
    return this.http.get<PaymentOption>(
      `${environment.resourceUrl}/api/payment/${id}`
    );
  }

  getTemporaryPassword(): Observable<any> {
    return this.http
      .get(`${environment.resourceUrl}/api/payment/proxy/id`)
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  validatePaymentMethod(model: any): Observable<any> {
    return this.http.post<any>(`${environment.resourceUrl}/api/payment/validateDeletePayment`, model);
  }

  deletePaymentMethod(model: any): Observable<any> {
    return this.http.post<any>(`${environment.resourceUrl}/api/payment/deletePayment`, model);
  }

  updatePaymentMethodSubscription(model: any): Observable<any> {
    return this.http.post<any>(`${environment.resourceUrl}/api/payment/update/paymentMethod/subscription`, model);
  }

  getInvoicesPastDue(): Observable<any> {
    return from(this.getAuthHeaders()).pipe(
      switchMap((headers) =>
        this.http.get(`${environment.resourceUrl}/api/payment/invoice/pastdue`, { headers })
      ),
      tap((response: any) => {
        this.transactionsSubject.next(response.transactions);
      }),
      catchError((error) => {
        console.error('Error fetching invoices:', error);
        return throwError(error);
      })
    );
  }


    paidPastDueInvoice(model): Observable<any> {
    return this.http
      .post<any>(`${environment.resourceUrl}/api/payment/process/transaction/pastdue`, model)
      .pipe(
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

}
